/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum DirectMessageIssueSelectionMode {
    None = '0',
    All = 1,
    Filtered = 2,
    Relative = 3,
}
